export class RPCError extends Error {
    constructor(params) {
        super(params.message);
        this.code = params.code;
        this.data = params.data;
    }
}
// TODO: throw exceptions on network failure
/**
 * RPC Service for interacting with the backend.
 */
export class RestaumaticRPCService {
    // TODO: url depending on envvars
    constructor(params) {
        this.url = params.url;
    }
    async post(path, data) {
        const r = await fetch(this.url + path, {
            method: "POST",
            headers: {
                "Content-type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify(data),
        });
        return (await r.json());
    }
    async get(path) {
        const r = await fetch(this.url + path, {
            headers: {
                Accept: "application/json",
            },
        });
        return (await r.json());
    }
    /**
     * Perform a RPC request to Restaumatic backend.
     * Throws RPCError when a RPC error response is received.
     */
    async rpc(method, params) {
        const response = await this.post(`/api/v1/sites/rpc?${method}`, {
            params,
            method,
            id: "1",
        });
        if ("error" in response) {
            throw new RPCError(response.error);
        }
        return response.result;
    }
    async rpc2(method, params) {
        return await this.post(`/api/v1/sites/rpc/${method}`, params);
    }
}
